import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#0f172a] border-t border-white/10 py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-outfit font-bold tracking-tighter text-white mb-3">
              TriVenza
            </h3>
            <p className="text-gray-400 font-manrope text-sm leading-relaxed">
              Media Production & Digital Services Company
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-outfit font-semibold text-white mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/"
                data-testid="footer-home-link"
                className="text-gray-400 hover:text-white font-manrope text-sm transition-colors duration-200"
              >
                Home
              </Link>
              <Link
                to="/about"
                data-testid="footer-about-link"
                className="text-gray-400 hover:text-white font-manrope text-sm transition-colors duration-200"
              >
                About
              </Link>
              <Link
                to="/services"
                data-testid="footer-services-link"
                className="text-gray-400 hover:text-white font-manrope text-sm transition-colors duration-200"
              >
                Services
              </Link>
              <Link
                to="/contact"
                data-testid="footer-contact-link"
                className="text-gray-400 hover:text-white font-manrope text-sm transition-colors duration-200"
              >
                Contact
              </Link>
            </div>
          </div>

          {/* Contact & Social */}
          <div>
            <h4 className="text-lg font-outfit font-semibold text-white mb-4">Get In Touch</h4>
            <div className="flex flex-col gap-2 mb-4">
              <a
                href="mailto:info@trivenzagroup.com"
                data-testid="footer-email"
                className="text-gray-400 hover:text-white font-manrope text-sm transition-colors duration-200"
              >
                info@trivenzagroup.com
              </a>
              <a
                href="tel:6287652887"
                data-testid="footer-phone"
                className="text-gray-400 hover:text-white font-manrope text-sm transition-colors duration-200"
              >
                +91 6287652887
              </a>
            </div>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/babylandrhymes"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="text-gray-400 hover:text-white transition-colors duration-200"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.youtube.com/@babylandrhymes"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-youtube"
                className="text-gray-400 hover:text-white transition-colors duration-200"
              >
                <Youtube size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-center">
          <p className="text-gray-500 font-manrope text-sm">
            © {new Date().getFullYear()} TriVenza Private Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;